import { render, staticRenderFns } from "./inTab1.vue?vue&type=template&id=f8e675d8&scoped=true&"
import script from "./inTab1.vue?vue&type=script&lang=js&"
export * from "./inTab1.vue?vue&type=script&lang=js&"
import style0 from "./inTab1.vue?vue&type=style&index=0&id=f8e675d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e675d8",
  null
  
)

export default component.exports